import React, { memo, useState } from 'react';
import { isToday } from '../../helpers/common';
import { DataTable, Icon, Span, Modal } from '../widgets';
import { deleteEquipment } from '../../actions/equipment';
import EquipmentForm from './EquipmentForm';
import { useDispatch } from 'react-redux';

const EquipmentItem = (props) => {

    const dispatch = useDispatch();
    const { equipment, search, index, farmId } = props;

    const [modalInfo, setModalInfo] = useState({ edit: false, delete: false, equipmentId: null, equipmentName: "" });
    const isActive = modalInfo.edit || modalInfo.delete;

    const handleModal = (type, show, id, name) => {
        setModalInfo({ ...modalInfo, [type]: show, equipmentId: id, equipmentName: name });
    };

    const handleDeleteConfim = () => {
        dispatch(deleteEquipment({
            equipment_uuid: modalInfo.equipmentId,
            farm_uuid: farmId
        }));
    };

    return <>
        <DataTable.Row className={`${!equipment.alive ? "not-alive-txt" : ""} ${isActive && "active"}`}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      >
            <DataTable.Cell style={{ width: "40px" }}>{index + 1}</DataTable.Cell>
            <DataTable.Cell>{equipment.name}</DataTable.Cell>
            <DataTable.Cell>{equipment.equipment_type_name}</DataTable.Cell>
            <DataTable.Cell>{`${equipment.equipment_category_name}${equipment.equipment_subcategory_name !== '' ? ' / ' + equipment.equipment_subcategory_name : ''}`}</DataTable.Cell>
            <DataTable.Cell>{equipment.equipment_make_name}</DataTable.Cell>
            <DataTable.Cell>{equipment.equipment_model_name}</DataTable.Cell>
            <DataTable.Cell>{equipment.year}</DataTable.Cell>
            <DataTable.Cell>{equipment.serial_number}</DataTable.Cell>
            {isToday(search.range) && <DataTable.Cell style={{ width: "64px" }} className="center">
                {equipment.alive && <><Icon
                    className="fa fa-pencil mr-1 cursor-pointer"
                    title="Edit"
                    onClick={() => handleModal("edit", true, equipment.equipment_uuid, "")} />
                    <Span className="btn-icon"><i className="fa fa-trash" title="Delete"
                        onClick={() => handleModal("delete", true, equipment.equipment_uuid, equipment.name)}></i>
                    </Span></>}
            </DataTable.Cell>}
        </DataTable.Row>
        {modalInfo.delete && <Modal.Confirm
            isOpen={true}
            onConfirm={handleDeleteConfim}
            iconClassName="fa fa-trash"
            body={`Do you really want to delete these ${modalInfo.equipmentName}?`}
            onHide={() => handleModal("delete", false, null, "")}
        />}
        {(modalInfo.edit && modalInfo.equipmentId) &&
            <Modal
                show={true}
                backdrop="static"
                className="equipment-modal-form">
                <EquipmentForm
                    onHide={() => handleModal("edit", false, null, "")}
                    farmId={farmId}
                    equipmentId={modalInfo.equipmentId}
                />
            </Modal>}
    </>
};

export default memo(EquipmentItem);